<div class="site-footer">
    <div class="container">
        <div class="site-footer__widgets">
            <div class="row">
                <div class="text-center col-12 col-md-4 col-lg-4">
                  
                </div>
                <div class="text-center col-6 col-md-4 col-lg-4">
            
                </div>
                <!-- <div class="d-none d-lg-block">
                </div> -->
            </div>
        </div>

        <div class="site-footer__bottom">
            <div class="site-footer__social">
                <app-social-links class="footer-newsletter__social-links" shape="circle"></app-social-links>

                <div class="site-footer__copyright site-footer__social--header d-none d-md-block">
                    Powered by <a href="http://mytidy.it/" target="_blank" rel="nofollow">MyTidy</a>
                </div>
            </div>

            <div class="site-footer__payments">
                <img src="assets/images/payments.png" alt="">
            </div>
        </div>
        <div class="site-footer__copyright pb-3 d-md-none">
            Powered by <a href="http://mytidy.it/" target="_blank" rel="nofollow">MyTidy</a>
        </div>
    </div>
</div>
